var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.57,81.82,420.2,78c-20-32.61-56.28-52.27-94.48-49.88a101.52,101.52,0,0,0-14.62,2c-34.74,7.34-65,33.28-77.49,66.5-7.37,19.53-9.42,42-23.41,57.53-18.19,20.18-49.08,20.82-76.24,20s-58.07-.12-76.18,20.14c-11.34,12.69-15,30.73-14,47.73,2.42,45,34.17,85.21,74.54,105.21s87.91,21.78,132.1,13c61.9-12.32,120.77-46.16,156.16-98.43S450.88,138.23,422.57,81.82Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.2,459c0,.15-101.37.26-226.39.26S25.4,459.16,25.4,459s101.35-.26,226.41-.26S478.2,458.87,478.2,459Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.13,
    y: 50.41,
    width: 284.59,
    height: 408.41,
    rx: 11.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.96,
    y: 79.55,
    width: 266.64,
    height: 341.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.42,
    cy: 438.3,
    r: 10.92,
    transform: "translate(-216.95 352.82) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.56,
    y: 62.17,
    width: 85.71,
    height: 4.51,
    rx: 1.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.49,
    cy: 395.89,
    r: 2.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.89,395.89a2.47,2.47,0,1,1-2.47-2.47A2.47,2.47,0,0,1,319.89,395.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,395.89a2.47,2.47,0,1,1-2.46-2.47A2.46,2.46,0,0,1,329.81,395.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.86,108.13H207.3a.48.48,0,1,1,0-.95h12.56a.48.48,0,1,1,0,.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18,112.14a.49.49,0,0,1-.28-.09l-5.64-4a.47.47,0,0,1,0-.78l5.81-4a.48.48,0,0,1,.66.13.47.47,0,0,1-.13.66l-5.24,3.58,5.08,3.62a.47.47,0,0,1,.12.66A.49.49,0,0,1,212.18,112.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.67,108.18H410.11a.48.48,0,0,1,0-1h12.56a.48.48,0,1,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.63,112.14a.49.49,0,0,1-.4-.21.48.48,0,0,1,.13-.66l5.24-3.58-5.08-3.61a.48.48,0,0,1-.12-.67.49.49,0,0,1,.67-.11l5.64,4a.47.47,0,0,1,.2.39.46.46,0,0,1-.21.39l-5.8,4A.56.56,0,0,1,417.63,112.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.69,108.61v1.33h-5.53V102.8h5.4v1.33h-3.75v1.55h3.31V107h-3.31v1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,102.8l-3.09,7.14H307L304,102.8h1.78l2.17,5.1,2.2-5.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.88,108.61v1.33h-5.52V102.8h5.39v1.33H314v1.55h3.31V107H314v1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.74,102.8v7.14h-1.35l-3.56-4.33v4.33H319.2V102.8h1.36l3.55,4.34V102.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.91,104.15h-2.28V102.8h6.22v1.35h-2.28v5.79h-1.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.12,109.24l.57-1.25a4.16,4.16,0,0,0,2.35.75c1,0,1.38-.33,1.38-.77,0-1.33-4.15-.42-4.15-3.07,0-1.21,1-2.22,3-2.22a4.86,4.86,0,0,1,2.48.63l-.51,1.26a4,4,0,0,0-2-.56c-1,0-1.35.36-1.35.81,0,1.32,4.15.41,4.15,3,0,1.19-1,2.21-3,2.21A5.12,5.12,0,0,1,333.12,109.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 134.84,
    width: 170.38,
    height: 61.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,148.65l.52-1.16a4,4,0,0,0,2.21.69c.92,0,1.3-.3,1.3-.71,0-1.26-3.9-.4-3.9-2.88,0-1.14.92-2.09,2.83-2.09a4.5,4.5,0,0,1,2.32.59l-.48,1.18a3.81,3.81,0,0,0-1.85-.53c-.92,0-1.28.35-1.28.77,0,1.23,3.9.38,3.9,2.84,0,1.12-.93,2.08-2.85,2.08A4.74,4.74,0,0,1,304.14,148.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.58,145.05c0,1.49-1.12,2.42-2.91,2.42h-1.35v1.84h-1.55v-6.69h2.9C315.46,142.62,316.58,143.54,316.58,145.05Zm-1.57,0c0-.74-.48-1.17-1.43-1.17h-1.26v2.32h1.26C314.53,146.2,315,145.77,315,145.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,146a3.67,3.67,0,1,1,3.66,3.47A3.46,3.46,0,0,1,317.36,146Zm5.76,0a2.1,2.1,0,1,0-2.1,2.15A2,2,0,0,0,323.12,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,149.31l-1.29-1.86H327.4v1.86h-1.54v-6.69h2.89c1.79,0,2.91.92,2.91,2.43a2.16,2.16,0,0,1-1.38,2.11l1.51,2.15Zm-1.45-5.43H327.4v2.33h1.27c.94,0,1.42-.44,1.42-1.16S329.61,143.88,328.67,143.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18,143.88H332v-1.26h5.83v1.26h-2.14v5.43h-1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,142.62h1.55v6.69h-1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,142.62v6.69h-1.27l-3.34-4.06v4.06h-1.53v-6.69h1.28l3.33,4.06v-4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.11,145.86h1.41v2.72a4.63,4.63,0,0,1-2.7.85,3.47,3.47,0,1,1,0-6.93,3.56,3.56,0,0,1,2.8,1.16l-1,.92a2.24,2.24,0,0,0-1.73-.76,2.15,2.15,0,1,0,0,4.29,2.48,2.48,0,0,0,1.21-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.33,148.74v.57H359.9V143h4.3v.58h-3.64v2.23h3.24v.56h-3.24v2.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,143l-2.77,6.27h-.66L364.81,143h.71l2.4,5.45,2.42-5.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,148.74v.57h-4.43V143h4.3v.58h-3.64v2.23h3.24v.56h-3.24v2.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.15,143v6.27h-.55l-4-5.08v5.08h-.66V143h.55l4,5.09V143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.41,143.62h-2.2V143h5.07v.58h-2.21v5.69h-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.8,199.78H205.56V130.12H436.8Zm-230.24-1H435.8V131.12H206.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.19,157.61H226.4a1.88,1.88,0,0,1-1.88-1.87v-9.66a1.88,1.88,0,0,1,1.88-1.87h10.79a1.87,1.87,0,0,1,1.87,1.87v9.66A1.87,1.87,0,0,1,237.19,157.61ZM226.4,145.16a.92.92,0,0,0-.92.92v9.66a.92.92,0,0,0,.92.92h10.79a.92.92,0,0,0,.92-.92v-9.66a.92.92,0,0,0-.92-.92Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.77,
    y: 141.72,
    width: 2.17,
    height: 4.04,
    rx: 1.03,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.21,
    y: 141.72,
    width: 2.17,
    height: 4.04,
    rx: 1.03,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 148.07,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.73,
    y: 148.07,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 152.17,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.73,
    y: 152.17,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,166.81v12.93h-3V169.21h-2.58v-2.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,177.31v2.43h-9.77V177.8l5-4.71c1.14-1.09,1.35-1.75,1.35-2.38,0-1-.71-1.61-2.07-1.61a3.18,3.18,0,0,0-2.68,1.29l-2.18-1.4a6,6,0,0,1,5.13-2.4c2.89,0,4.81,1.48,4.81,3.82,0,1.26-.35,2.4-2.16,4.09l-3,2.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,183.74c0,.15-5.82.26-13,.26s-13-.11-13-.26,5.82-.26,13-.26S243.72,183.6,243.72,183.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.21,187.62a67.8,67.8,0,0,1-8.33.26,68,68,0,0,1-8.34-.26,65.73,65.73,0,0,1,8.34-.26A65.5,65.5,0,0,1,241.21,187.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,196.52c-.14,0-.26-13.81-.26-30.84s.12-30.84.26-30.84.26,13.81.26,30.84S260,196.52,259.89,196.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,195.43c38-41.59,121.94-16.75,121.94-16.75l-1.37-9.22c-69.7-24.14-120.57-18.88-120.57-18.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.54,190.33c0,.15-23.12.26-51.63.26s-51.64-.11-51.64-.26,23.11-.26,51.64-.26S382.54,190.19,382.54,190.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.19,
    cy: 169.7,
    r: 23.9,
    transform: "translate(127.92 510.43) rotate(-73.59)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.59,183.69a16.52,16.52,0,0,0-4.1.31,32.62,32.62,0,0,0,8.22-.1A17.2,17.2,0,0,0,390.59,183.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.64,173.72c-.65-.87-1.91-2.43-3.42-4.19A48.06,48.06,0,0,0,417,165l1.18-7.46a28.78,28.78,0,0,0,2.93-.78,12,12,0,0,0,3.24-1.29,12.63,12.63,0,0,0-3.4.8c-1.14.36-2.14.72-2.72,1v-.07l-8.23-4.2L410,153a18.37,18.37,0,0,0-1.48-2.08,16.47,16.47,0,0,0-2.8-2.76L408,146s-1.59-.46-5.63,0-3.86,2.12-3.86,2.12l6.92.15c.46.53,1.53,1.62,2.66,3,.61.75,1.14,1.47,1.57,2.06l-6.1,6.11a39.68,39.68,0,0,0-4.23.36,22.57,22.57,0,0,0-4.8.87,24.12,24.12,0,0,0,4.86-.36c1.82-.23,3.38-.47,4.19-.63l4,7.79-.55.84c-.67,1.06-1.54,2.56-2.4,4.27s-1.47,3.1-1.92,4.24l-6.34-.65c-.31-.73-.67-1.55-1.06-2.43-.87-1.93-1.67-3.56-2.12-4.38l1.37-8.69L388.71,156c.61-.34,2.63-1.85,5-3.73a39.69,39.69,0,0,0,4.86-4.2,41.72,41.72,0,0,0-5.18,3.8c-2.39,1.9-4.32,3.56-4.76,4l-.28-.22-5.8,5.86,2.93,8.52c-.28.59-.83,2.11-1.49,3.89a26.06,26.06,0,0,0-1.42,4.26,16,16,0,0,0,1.9-4.08,25.94,25.94,0,0,0,1.19-4l7.33-.55c.34.92,1,2.52,1.82,4.32.4.88.77,1.68,1.11,2.39l-1.2,7.59,7.09,5.64,0,0a15.25,15.25,0,0,0,1.55,2.19,8.41,8.41,0,0,0,2,2.09,8.3,8.3,0,0,0-1.61-2.41,15.52,15.52,0,0,0-1.8-2l5.45-4.19-3.62-8.31-.73-.07c.52-1.1,1.19-2.51,2-4.06,1.08-2.13,2.09-4,2.67-5.08l9.1-1.44.19-1.19a58,58,0,0,0,3.84,4.8c1.43,1.67,2.73,3.11,3.51,3.92l-.13,0-5.28,8.51.06.08c-1.1.19-3.1.61-5.39,1.15-1.73.41-3.28.8-4.4,1.1a10.76,10.76,0,0,0-1.79.56c0,.19,2.86-.35,6.3-1.16,2.37-.56,4.39-1.09,5.43-1.42l2.75,4.12a18.55,18.55,0,0,0,6.84-13.87v-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.14,172.33v1.85h-7.41V172.7l3.78-3.57c.87-.82,1-1.33,1-1.8,0-.77-.53-1.22-1.57-1.22a2.4,2.4,0,0,0-2,1L279.28,166a4.57,4.57,0,0,1,3.89-1.82c2.19,0,3.65,1.12,3.65,2.9,0,1-.27,1.82-1.64,3.1l-2.26,2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,164.37v9.81h-2.27v-8h-2v-1.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,167.89a1.36,1.36,0,0,1,2.72,0,1.36,1.36,0,1,1-2.72,0Zm0,5a1.36,1.36,0,0,1,2.72,0,1.36,1.36,0,1,1-2.72,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,169.27c0-3.23,1.79-5.07,4.2-5.07s4.21,1.84,4.21,5.07-1.78,5.07-4.21,5.07S297.24,172.51,297.24,169.27Zm6.12,0c0-2.22-.78-3.15-1.92-3.15s-1.9.93-1.9,3.15.78,3.15,1.9,3.15S303.36,171.5,303.36,169.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,169.27c0-3.23,1.8-5.07,4.21-5.07s4.2,1.84,4.2,5.07-1.78,5.07-4.2,5.07S306.75,172.51,306.75,169.27Zm6.13,0c0-2.22-.79-3.15-1.92-3.15s-1.91.93-1.91,3.15.79,3.15,1.91,3.15S312.88,171.5,312.88,169.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.52,172.33v1.85h-7.41V172.7l3.79-3.57c.86-.82,1-1.33,1-1.8,0-.77-.53-1.22-1.57-1.22a2.38,2.38,0,0,0-2,1L323.66,166a4.58,4.58,0,0,1,3.9-1.82c2.18,0,3.64,1.12,3.64,2.9,0,1-.26,1.82-1.64,3.1l-2.25,2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.7,171.18c0,1.65-1.27,3.16-4.06,3.16a6.7,6.7,0,0,1-3.74-1.05l.88-1.73a4.79,4.79,0,0,0,2.81.88c1.13,0,1.83-.46,1.83-1.26s-.54-1.21-1.83-1.21h-1v-1.5l2-2.28h-4.18v-1.82h6.87v1.47L337,168.36A2.79,2.79,0,0,1,339.7,171.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.69,167.89a1.36,1.36,0,0,1,2.71,0,1.36,1.36,0,1,1-2.71,0Zm0,5a1.36,1.36,0,0,1,2.71,0,1.36,1.36,0,1,1-2.71,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,169.27c0-3.23,1.79-5.07,4.2-5.07s4.2,1.84,4.2,5.07-1.78,5.07-4.2,5.07S344.43,172.51,344.43,169.27Zm6.12,0c0-2.22-.79-3.15-1.92-3.15s-1.9.93-1.9,3.15.78,3.15,1.9,3.15S350.55,171.5,350.55,169.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94,169.27c0-3.23,1.79-5.07,4.2-5.07s4.21,1.84,4.21,5.07-1.78,5.07-4.21,5.07S353.94,172.51,353.94,169.27Zm6.12,0c0-2.22-.78-3.15-1.92-3.15s-1.9.93-1.9,3.15.78,3.15,1.9,3.15S360.06,171.5,360.06,169.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,151.68c0,.15-19.18.27-42.84.27s-42.84-.12-42.84-.27,19.18-.26,42.84-.26S383.74,151.54,383.74,151.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.13,185.09c0,.15-13.15.26-29.38.26s-29.39-.11-29.39-.26,13.16-.26,29.39-.26S370.13,185,370.13,185.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 224.31,
    width: 170.38,
    height: 61.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67,239.72v-4l-2,3.31H292l-2-3.23v3.94h-1.45V233h1.28l2.51,4.16,2.46-4.16h1.28l0,6.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,236.77V233h1.55v3.69c0,1.27.56,1.8,1.49,1.8s1.49-.53,1.49-1.8V233h1.54v3.75a3,3,0,1,1-6.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,239.06l.53-1.17a4,4,0,0,0,2.21.7c.92,0,1.29-.31,1.29-.72,0-1.25-3.89-.39-3.89-2.88,0-1.14.92-2.09,2.82-2.09a4.41,4.41,0,0,1,2.32.6l-.47,1.17a3.86,3.86,0,0,0-1.86-.52c-.92,0-1.27.34-1.27.76,0,1.24,3.89.39,3.89,2.84,0,1.12-.93,2.08-2.84,2.08A4.8,4.8,0,0,1,304.73,239.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,233h1.55v6.7h-1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.08,236.37a3.68,3.68,0,0,1,6.39-2.28l-1,.92a2.14,2.14,0,0,0-1.68-.79,2.15,2.15,0,1,0,0,4.29,2.14,2.14,0,0,0,1.68-.79l1,.91a3.68,3.68,0,0,1-6.39-2.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.8,238.28h-3.11l-.6,1.44h-1.58l3-6.7H325l3,6.7h-1.63Zm-.49-1.18-1.06-2.56-1.06,2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,233h1.55v5.43h3.36v1.27h-4.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.24,239.1v.62H337.5V233h4.6v.61h-3.89V236h3.47v.61h-3.47v2.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.38,233l-3,6.7h-.69l-3-6.7h.77l2.56,5.82,2.58-5.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08,239.1v.62h-4.73V233h4.59v.61h-3.88V236h3.46v.61h-3.46v2.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.35,233v6.7h-.58l-4.31-5.44v5.44h-.71V233h.59l4.31,5.43V233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.83,233.63h-2.35V233h5.42v.61h-2.36v6.09h-.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.8,289.25H205.56V219.6H436.8Zm-230.24-1H435.8V220.6H206.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.19,247.09H226.4a1.89,1.89,0,0,1-1.88-1.88v-9.65a1.88,1.88,0,0,1,1.88-1.88h10.79a1.88,1.88,0,0,1,1.87,1.88v9.65A1.88,1.88,0,0,1,237.19,247.09ZM226.4,234.63a.93.93,0,0,0-.92.93v9.65a.92.92,0,0,0,.92.92h10.79a.92.92,0,0,0,.92-.92v-9.65a.93.93,0,0,0-.92-.93Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.77,
    y: 231.2,
    width: 2.17,
    height: 4.04,
    rx: 1.03,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.21,
    y: 231.2,
    width: 2.17,
    height: 4.04,
    rx: 1.03,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 237.55,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.73,
    y: 237.55,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 241.64,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.73,
    y: 241.64,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,256.28v12.94h-3V258.68h-2.58v-2.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,262.47c0,4.47-2.68,7-6.6,7a6.9,6.9,0,0,1-3.58-.89l1.11-2.2a4.18,4.18,0,0,0,2.42.65c2.14,0,3.54-1.28,3.64-3.77a4.42,4.42,0,0,1-3.22,1.16c-2.49,0-4.45-1.59-4.45-4,0-2.64,2.16-4.3,4.89-4.3C238.6,256.06,240.8,258.3,240.8,262.47Zm-3.35-2.25c0-1.11-.83-1.92-2.25-1.92a1.92,1.92,0,0,0-2.16,1.92,2,2,0,0,0,2.2,1.94A2,2,0,0,0,237.45,260.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,273.21c0,.15-5.82.27-13,.27s-13-.12-13-.27,5.82-.26,13-.26S243.72,273.07,243.72,273.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.21,277.09a67.8,67.8,0,0,1-8.33.26,68,68,0,0,1-8.34-.26,65.73,65.73,0,0,1,8.34-.26A65.5,65.5,0,0,1,241.21,277.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,286c-.14,0-.26-13.81-.26-30.84s.12-30.84.26-30.84.26,13.81.26,30.84S260,286,259.89,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.86,245.07c0,.15-21.94.26-49,.26s-49-.11-49-.26,21.94-.26,49-.26S373.86,244.93,373.86,245.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.54,249.24c0,.14-13.15.26-29.38.26s-29.39-.12-29.39-.26,13.16-.26,29.39-.26S354.54,249.09,354.54,249.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.6,270.32a4,4,0,0,0,.53.87,4.73,4.73,0,0,0,2.48,1.51,23.67,23.67,0,0,0,4.65.44,30.35,30.35,0,0,0,6.18-.27,13.63,13.63,0,0,0,3.42-1,12.49,12.49,0,0,0,3.21-2.16c2-1.8,3.67-4.2,5.85-6.35a24.08,24.08,0,0,1,3.67-2.93c.67-.44,1.4-.82,2.1-1.21a4.38,4.38,0,0,0,1.77-1.55,1.56,1.56,0,0,0,.14-1.12,1.83,1.83,0,0,0-.66-.94,3,3,0,0,0-2.34-.44,13.68,13.68,0,0,0-4.76,1.87c-.75.45-1.39,1-2.12,1.53a4.44,4.44,0,0,1-1.19.6,1.81,1.81,0,0,1-1.35-.07,2,2,0,0,1-.9-1,7.09,7.09,0,0,1-.43-1.22,14.26,14.26,0,0,1-.47-2.48,15.05,15.05,0,0,1,.35-4.89A41,41,0,0,1,415.1,245a24.29,24.29,0,0,0,1.89-8.35,11.53,11.53,0,0,0-.21-2c-.07-.31-.16-.62-.24-.93a2.14,2.14,0,0,0-.42-.79,1.22,1.22,0,0,0-1.57,0,2.35,2.35,0,0,0-.86,1.42c-.13.55-.2,1.11-.29,1.65s-.2,1.06-.31,1.57c-.21,1-.45,2-.7,2.85a42.3,42.3,0,0,1-1.5,4.45,10.65,10.65,0,0,1-1.34,2.65,3.14,3.14,0,0,1-.74.72l.19-.18a4.18,4.18,0,0,0,.51-.58,11.21,11.21,0,0,0,1.29-2.65c.45-1.2,1-2.68,1.45-4.45.24-.88.47-1.83.68-2.84.1-.51.2-1,.29-1.57s.15-1.1.29-1.67a2.53,2.53,0,0,1,.93-1.54,1.87,1.87,0,0,1,.9-.31,1.21,1.21,0,0,1,.93.35,2.09,2.09,0,0,1,.46.87,7.36,7.36,0,0,1,.25.95,10.21,10.21,0,0,1,.22,2,24.24,24.24,0,0,1-1.87,8.43,41.31,41.31,0,0,0-1.36,4.46,14.8,14.8,0,0,0-.33,4.8,13.63,13.63,0,0,0,.46,2.44,7.83,7.83,0,0,0,.41,1.18,1.75,1.75,0,0,0,.79.86,1.52,1.52,0,0,0,1.15.06,4.09,4.09,0,0,0,1.12-.57c.71-.47,1.37-1.07,2.13-1.53a13.88,13.88,0,0,1,4.87-1.91,3.29,3.29,0,0,1,2.53.49,2,2,0,0,1,.75,1.08,1.8,1.8,0,0,1-.16,1.31,4.63,4.63,0,0,1-1.87,1.65c-.72.4-1.42.77-2.09,1.21a22.51,22.51,0,0,0-3.64,2.88c-2.16,2.12-3.83,4.53-5.87,6.34A12.92,12.92,0,0,1,411,272a14.63,14.63,0,0,1-3.48,1,31.29,31.29,0,0,1-6.22.23,22.93,22.93,0,0,1-4.67-.5,4.76,4.76,0,0,1-2.49-1.56,3.36,3.36,0,0,1-.4-.66A2.08,2.08,0,0,1,393.6,270.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,249.63a1.07,1.07,0,0,1-.41-.33,2.3,2.3,0,0,1-.49-1.41,15.87,15.87,0,0,1,.12-2.36c.08-.92.15-2,.21-3.13s.11-2.43.11-3.78a2,2,0,0,0-.78-1.76,1.43,1.43,0,0,0-1-.26,1.29,1.29,0,0,0-.87.52,5.44,5.44,0,0,0-.74,2.15,19.24,19.24,0,0,0-.22,2.44c-.07,1.66-.08,3.39-.09,5.16s0,3.5-.09,5.17-.22,3.29-.42,4.81a54.81,54.81,0,0,0-.65,8.1,18.28,18.28,0,0,0,.9,5.38c.21.61.42,1.07.56,1.38.07.14.12.26.17.35l.05.12s0,0-.08-.11l-.19-.34a11.32,11.32,0,0,1-.6-1.37,17.21,17.21,0,0,1-1-5.4,51.7,51.7,0,0,1,.59-8.14,74.48,74.48,0,0,0,.49-9.95c0-1.77,0-3.5.1-5.18a18.14,18.14,0,0,1,.22-2.46,5.43,5.43,0,0,1,.8-2.25,1.5,1.5,0,0,1,1-.62,1.73,1.73,0,0,1,1.12.31,1.82,1.82,0,0,1,.7.88,3.35,3.35,0,0,1,.17,1.06c0,1.38-.07,2.64-.14,3.8s-.16,2.21-.25,3.13a16.68,16.68,0,0,0-.17,2.35,2.44,2.44,0,0,0,.43,1.38A2.05,2.05,0,0,0,398,249.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,249.31a1.88,1.88,0,0,1,.3-.29,3.44,3.44,0,0,1,1-.6,4.27,4.27,0,0,1,1.87-.23,4.55,4.55,0,0,1,2.33.89,2.53,2.53,0,0,1,.9,1.17,11,11,0,0,1,.28,1.56,15,15,0,0,1,.11,1.68c0,.57,0,1.16.05,1.77,0,1.21.07,2.49.11,3.81l.06,2a11.42,11.42,0,0,1-.05,2.1,2.29,2.29,0,0,1-.42,1,2.31,2.31,0,0,1-.86.66,2.36,2.36,0,0,1-2.06-.05,2.67,2.67,0,0,1-1.19-1.6,11.32,11.32,0,0,1-.42-1.84c-.35-2.42-.26-4.62-.45-6.44a13.36,13.36,0,0,0-1-4.2,9,9,0,0,0-.53-1q-.21-.35-.21-.36a2.49,2.49,0,0,1,.26.33,9.81,9.81,0,0,1,.58,1,13.11,13.11,0,0,1,1.07,4.22c.21,1.83.14,4,.5,6.42a11.45,11.45,0,0,0,.42,1.8,2.43,2.43,0,0,0,1.07,1.45,2.1,2.1,0,0,0,1.83,0,2,2,0,0,0,.76-.58,2.23,2.23,0,0,0,.37-.9,11.68,11.68,0,0,0,.05-2.05l-.06-2c0-1.32-.06-2.6-.09-3.81,0-.61,0-1.2,0-1.78a14.81,14.81,0,0,0-.1-1.66,11.48,11.48,0,0,0-.25-1.52,2.4,2.4,0,0,0-.82-1.08,4.38,4.38,0,0,0-2.23-.89,4.44,4.44,0,0,0-1.82.17A5.09,5.09,0,0,0,398.08,249.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.7,249.28a1.53,1.53,0,0,1,.12-.28,2,2,0,0,1,.6-.62,4.31,4.31,0,0,1,1.25-.53,4.16,4.16,0,0,1,1.8-.16,3.42,3.42,0,0,1,1.87,1.14,5,5,0,0,1,1.16,2.23,11.52,11.52,0,0,1,.14,2.77c0,.95-.1,1.94-.22,2.95s-.29,2-.48,2.91a14.75,14.75,0,0,1-.75,2.67,3.31,3.31,0,0,1-1.67,1.86,1.83,1.83,0,0,1-1.17.12,1.48,1.48,0,0,1-.88-.63,3.16,3.16,0,0,1-.41-1.77c0-.53.08-1,.08-1.34a3.75,3.75,0,0,0-.14-1.13s0,0,0,.07a.76.76,0,0,1,.08.21,3,3,0,0,1,.13.85c0,.37,0,.82,0,1.35a3,3,0,0,0,.41,1.65,1.29,1.29,0,0,0,.78.54,1.63,1.63,0,0,0,1-.12,3.14,3.14,0,0,0,1.54-1.76,15.17,15.17,0,0,0,.72-2.62c.19-.93.35-1.9.47-2.9s.19-2,.22-2.92a11.46,11.46,0,0,0-.12-2.71,4.84,4.84,0,0,0-1.08-2.13,3.18,3.18,0,0,0-1.74-1.11,4.07,4.07,0,0,0-1.73.12,4.32,4.32,0,0,0-1.23.48A2.14,2.14,0,0,0,403.7,249.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.61,256.59a2.53,2.53,0,0,1-1.81-.21,2.5,2.5,0,0,1-1.38-1.2,5.58,5.58,0,0,0,3.19,1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.68,270.16c-.05,0-.1-.73-.41-1.87a12.75,12.75,0,0,0-.68-2,13.19,13.19,0,0,0-2.86-4.13,13.14,13.14,0,0,0-1.58-1.33c-.95-.69-1.62-1-1.6-1.05a2.12,2.12,0,0,1,.48.19,4.73,4.73,0,0,1,.54.28,8,8,0,0,1,.69.42A12.83,12.83,0,0,1,399.9,262a13.72,13.72,0,0,1,1.67,2,13.07,13.07,0,0,1,1.24,2.26,12.42,12.42,0,0,1,.65,2c.07.28.1.55.14.79a3.82,3.82,0,0,1,.07.6A1.59,1.59,0,0,1,403.68,270.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.12,250.42a2.54,2.54,0,0,1-.59,1.45,2.65,2.65,0,0,1-1.15,1.06c-.05-.06.46-.52.93-1.21S412.05,250.4,412.12,250.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,268.72a2.94,2.94,0,0,1,.5,1.08,5,5,0,0,1-.28,3.21,6.4,6.4,0,0,1-1.21,1.9,7.36,7.36,0,0,1-2.1,1.52,14.93,14.93,0,0,1-5.74,1.3,21,21,0,0,1-5.88-.26,9.08,9.08,0,0,1-4.3-2.13,6.52,6.52,0,0,1-1.82-2.67,3,3,0,0,1-.15-.49,3.35,3.35,0,0,1-.07-.37,1.14,1.14,0,0,1,0-.3s.07.42.34,1.13a6.7,6.7,0,0,0,1.86,2.56,9,9,0,0,0,4.22,2,21.64,21.64,0,0,0,5.81.23,15.08,15.08,0,0,0,5.65-1.26,6.94,6.94,0,0,0,2.05-1.45,6.7,6.7,0,0,0,1.2-1.83,4.91,4.91,0,0,0,.35-3.11A7.84,7.84,0,0,0,415.25,268.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,271.94a14.67,14.67,0,0,1,1.46-.88c.9-.53,2.12-1.3,3.42-2.24l.46-.33.09.23a22.7,22.7,0,0,0-3.65.61c-.9.22-1.45.4-1.46.36a1.17,1.17,0,0,1,.37-.17,10.14,10.14,0,0,1,1-.36,18,18,0,0,1,3.66-.7l.47,0-.38.28-.46.34a30.12,30.12,0,0,1-3.48,2.18c-.47.25-.85.44-1.12.56S415.05,272,415,271.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,272.68a8,8,0,0,1,1,.54c.64.36,1.55.89,2.61,1.52l.17.1-.17.1A2,2,0,0,0,408,276a2.91,2.91,0,0,1-.78,1.33,1.05,1.05,0,0,1-.61.26,1.13,1.13,0,0,1-.63-.14,4.56,4.56,0,0,1-.91-.67,4.4,4.4,0,0,0-1.56-1.09l-.13,0,.08-.12c.47-.71.87-1.29,1.15-1.69a4.21,4.21,0,0,1,.47-.61,2.86,2.86,0,0,1-.37.68c-.25.41-.62,1-1.08,1.73l-.06-.15a4.5,4.5,0,0,1,1.66,1.1,4.49,4.49,0,0,0,.87.63.81.81,0,0,0,.95-.09,2.78,2.78,0,0,0,.71-1.22,2.19,2.19,0,0,1,.8-1.19V275l-2.55-1.6A6.48,6.48,0,0,1,405,272.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,275.12a2,2,0,0,1-.54.11c-.35,0-.86.11-1.49.17a38.77,38.77,0,0,1-5,.07l-.44,0-.59,0,.55-.22a40.54,40.54,0,0,0,4.18-2c1-.57,1.65-.94,1.67-.91a2.22,2.22,0,0,1-.4.31c-.27.19-.67.45-1.18.75a30.43,30.43,0,0,1-4.17,2.07l0-.25.44,0a47.58,47.58,0,0,0,4.93,0l1.49-.08A2.32,2.32,0,0,1,396,275.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,230.25c.44.52,7.07,11.62,7.07,11.62l-3,.51s3.51,9.58,3.1,9.29-9.85-11-9.85-11l4.33-2.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.15,239.72c-.22.26-3.53,5.81-3.53,5.81l1.51.25s-1.75,4.79-1.55,4.65,4.93-5.52,4.93-5.52l-2.17-1.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,280.76c.29-.18,5.11-4.5,5.11-4.5l-1.38-.69s3.1-4.06,2.86-4-6.34,3.82-6.34,3.82l1.66,1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,227.5c-.16.45-1.8,9.35-1.8,9.35l2.11-.41s0,7.14.24,6.85,3.76-9.65,3.76-9.65l-3.51-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.71,270c-.51.92-1,1.82-1.49,2.71a1,1,0,0,1-.53.44,1.29,1.29,0,0,1-.83-.26c-.44-.27-.83-.5-1.17-.68a4,4,0,0,1-.94-.7,1.64,1.64,0,0,1-.47-.91,2.3,2.3,0,0,1,.21-1.13l.65-1.56c.28-.69.6-1.46,1-2.32s.76-1.78,1.2-2.76.87-2,1.32-2.94.9-1.92,1.36-2.83.89-1.71,1.3-2.42a11.37,11.37,0,0,1,1.17-1.71,1.9,1.9,0,0,1,.95-.73c1.24-.16,2.53-.28,3.86-.39a18.58,18.58,0,0,1,3.82.08,10.21,10.21,0,0,1,3.28,1,5.07,5.07,0,0,1,2.27,2.22,17.84,17.84,0,0,1,1,2.67,9.83,9.83,0,0,1,.3,3.17,4.53,4.53,0,0,1-1.17,2.81,10,10,0,0,1-4.08,2.4,31,31,0,0,1-6,1.26c.26.58.56,1.2.88,1.86s.66,1.32,1,2,.7,1.32,1.06,1.95.69,1.19,1,1.68.34.69.25.85a1.06,1.06,0,0,1-.62.42,2.06,2.06,0,0,1-.94.18l-.85-.1a3.78,3.78,0,0,1-1.3-.31,4.22,4.22,0,0,1-1.43-1.12c-.31-.41-.67-.91-1.07-1.49s-.79-1.22-1.19-1.91-.8-1.39-1.19-2.12a20.53,20.53,0,0,1-1-2.14C294.76,268.1,294.22,269.06,293.71,270Zm6.07-10.07c-.58.94-1.22,1.93-1.91,3a16.16,16.16,0,0,0,3.69-.48,15.88,15.88,0,0,0,2.92-1.06,7.05,7.05,0,0,0,1.9-1.3,1.79,1.79,0,0,0,.66-1.18c-.06-.56-.6-1-1.64-1.32a9.09,9.09,0,0,0-1.74-.34,8.42,8.42,0,0,0-2.16.08C300.94,258.1,300.37,259,299.78,259.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,261.15a7.78,7.78,0,0,1,.36,2.24,20.27,20.27,0,0,1-.56,4.34,23.68,23.68,0,0,1-1.54,4.5,21.84,21.84,0,0,1-2.44,4.07,12.59,12.59,0,0,1-3.27,3,6.07,6.07,0,0,1-2.46.77,8.47,8.47,0,0,1-2.77-.32,20,20,0,0,1-2.07-.68,8,8,0,0,1-1.88-1,8.15,8.15,0,0,1-1.29-1.22,4.55,4.55,0,0,1-.9-1.54,11,11,0,0,1-.52-3,15.68,15.68,0,0,1,.23-3.38,18.35,18.35,0,0,1,1-3.48,17.79,17.79,0,0,1,1.68-3.35,18,18,0,0,1,2.33-3,15.09,15.09,0,0,1,2.93-2.36,6.81,6.81,0,0,1,2.46-.75,5.66,5.66,0,0,1,2.55.21,16.35,16.35,0,0,1,2.83,1.23,8.64,8.64,0,0,1,2.13,1.63A5.69,5.69,0,0,1,329,261.15Zm-7.4.26a9.36,9.36,0,0,0-1.71,1.59,19.28,19.28,0,0,0-1.72,2.33,22.14,22.14,0,0,0-1.43,2.55,16.81,16.81,0,0,0-1.49,5.11,6.46,6.46,0,0,0,.06,2.09,1.57,1.57,0,0,0,.78,1.19,1.34,1.34,0,0,0,1.24,0,5.38,5.38,0,0,0,1.47-1.14,12.9,12.9,0,0,0,1.54-2,20.36,20.36,0,0,0,1.42-2.72,21.23,21.23,0,0,0,1-2.72,20.24,20.24,0,0,0,.67-2.84,9,9,0,0,0,.12-2.37c-.07-.67-.28-1.09-.62-1.26A1.31,1.31,0,0,0,321.62,261.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.34,273.91a2.67,2.67,0,0,1-.12,1.49,7.86,7.86,0,0,1-.87,2.05,10.22,10.22,0,0,1-1.23,1.66,5.74,5.74,0,0,1-.81.65,6.85,6.85,0,0,1-1,.58,8.25,8.25,0,0,1-1.18.45,7.7,7.7,0,0,1-1.23.26,10.1,10.1,0,0,1-2.37.08c-.73-.06-1.38-.12-2-.19a6.38,6.38,0,0,1-1.64-.56,4.49,4.49,0,0,1-1.41-1.08,8.16,8.16,0,0,1-1.56-2.54,15.59,15.59,0,0,1-.91-3.33,21.4,21.4,0,0,1-.25-3.81,23.21,23.21,0,0,1,.45-4,20.64,20.64,0,0,1,1.17-3.8,14.46,14.46,0,0,1,1.9-3.35,5.86,5.86,0,0,1,2-1.75,6.78,6.78,0,0,1,2.14-.67,12.41,12.41,0,0,1,1.63-.05,15.05,15.05,0,0,1,1.66.16,13.85,13.85,0,0,1,1.56.32,12.1,12.1,0,0,1,1.36.44,6.12,6.12,0,0,1,1,.67,4.94,4.94,0,0,1,.72.73,3.92,3.92,0,0,1,.47.85,7.68,7.68,0,0,1,.32,1,12,12,0,0,1,.26,1.3c.07.45.12.91.16,1.36s.05.89.05,1.31,0,.81-.07,1.16c0,.15-.05.3-.08.44a.67.67,0,0,1-.16.34.92.92,0,0,1-.39.23,3.3,3.3,0,0,1-.74.09,6.35,6.35,0,0,1-1.58-.13,3.76,3.76,0,0,1-1.17-.46,3.23,3.23,0,0,1-.84-.77,4.84,4.84,0,0,1-.6-1.11,8.38,8.38,0,0,1-.3-1,8.71,8.71,0,0,0-.41-1.55,1.1,1.1,0,0,0-.84-.78c-.38,0-.76.26-1.14.89a12.2,12.2,0,0,0-1.05,2.35,24.19,24.19,0,0,0-.84,3.06,23.69,23.69,0,0,0-.45,3,21.57,21.57,0,0,0,0,2.79,13,13,0,0,0,.38,2.46,6.08,6.08,0,0,0,.74,1.77,1.43,1.43,0,0,0,1.06.74c.77.08,1.73-.79,2.89-2.61a4,4,0,0,1,4-1.76C345.82,273.34,346.23,273.54,346.34,273.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.43,265.92c.68.36,1.34.7,2,1s1.26.61,1.84.87,1.06.47,1.48.62.65.3.68.5a1.22,1.22,0,0,1-.36.83,4.29,4.29,0,0,1-.58.68,7.12,7.12,0,0,1-.76.62,3.4,3.4,0,0,1-1.25.75,2.6,2.6,0,0,1-1.74-.1l-1.16-.42-1.63-.63c-.6-.25-1.23-.51-1.89-.8s-1.29-.58-1.89-.89c.36,1.19.69,2.27,1,3.25s.6,1.87.86,2.67a.67.67,0,0,1,.09.59.88.88,0,0,1-.42.38,3.92,3.92,0,0,1-.85.26l-1.13.24a4.49,4.49,0,0,1-2,.11,1.8,1.8,0,0,1-1.14-1.11c-.29-.58-.63-1.35-1-2.31s-.83-2-1.29-3.2-.92-2.41-1.4-3.71-.93-2.57-1.37-3.83-.84-2.45-1.21-3.58-.68-2.13-.92-3a1.31,1.31,0,0,1,.14-1.15,1.89,1.89,0,0,1,1.13-.52,13.35,13.35,0,0,1,2-.3,11.79,11.79,0,0,1,2,0,5.92,5.92,0,0,1,.81.12,1.18,1.18,0,0,1,.52.21.85.85,0,0,1,.3.39,3.06,3.06,0,0,1,.17.61c.19,1,.45,2,.77,3.23s.68,2.49,1.07,3.91c.29-1.11.6-2.3.95-3.58s.67-2.52,1-3.75.61-2.39.87-3.49.47-2,.62-2.76a1.24,1.24,0,0,1,.49-1,1.69,1.69,0,0,1,1.16,0,5.12,5.12,0,0,1,1.43.55,13.6,13.6,0,0,1,1.32.87,2.48,2.48,0,0,1,.69,1,3.88,3.88,0,0,1,.14,1.55,18.56,18.56,0,0,1-.41,2.85c-.22,1.09-.5,2.22-.82,3.4s-.67,2.37-1.06,3.57-.75,2.34-1.1,3.4C359.11,265.2,359.75,265.56,360.43,265.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 313.79,
    width: 170.38,
    height: 61.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.79,324.77H276V327a3.73,3.73,0,0,1-2.22.7,2.85,2.85,0,1,1,0-5.68,2.91,2.91,0,0,1,2.29.95l-.81.76a1.85,1.85,0,0,0-1.42-.62,1.76,1.76,0,1,0,0,3.51,1.93,1.93,0,0,0,1-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.74,326.42h-2.55l-.49,1.18h-1.3l2.45-5.49h1.25l2.46,5.49h-1.34Zm-.4-1-.87-2.11-.87,2.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,327.6v-3.3L286.5,327h-.58l-1.6-2.65v3.23h-1.2v-5.49h1.05l2.06,3.41,2-3.41h1.05v5.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.86,326.58v1h-4.25v-5.49h4.15v1h-2.89v1.19h2.55v1h-2.55v1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.36,327.6l-1.06-1.53h-1.16v1.53h-1.28v-5.49h2.38c1.47,0,2.39.76,2.39,2a1.78,1.78,0,0,1-1.13,1.73l1.23,1.77Zm-1.19-4.46h-1v1.92h1c.78,0,1.17-.37,1.17-1S299,323.14,298.17,323.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,327.1v.5h-3.89v-5.49h3.77v.5h-3.19v1.95h2.84v.5h-2.84v2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,322.11l-2.43,5.49h-.57l-2.43-5.49H309l2.11,4.77,2.11-4.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,327.1v.5H314.6v-5.49h3.76v.5h-3.18v1.95H318v.5h-2.84v2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,322.11v5.49H324l-3.53-4.46v4.46h-.58v-5.49h.48l3.54,4.45v-4.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.28,322.61h-1.93v-.5h4.44v.5h-1.93v5h-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.8,378.73H205.56V309.07H436.8Zm-230.24-1H435.8V310.07H206.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,336.57H228.82a1.89,1.89,0,0,1-1.88-1.88V325a1.88,1.88,0,0,1,1.88-1.88h10.79a1.88,1.88,0,0,1,1.87,1.88v9.65A1.88,1.88,0,0,1,239.61,336.57Zm-10.79-12.46a.93.93,0,0,0-.92.93v9.65a.92.92,0,0,0,.92.92h10.79a.92.92,0,0,0,.92-.92V325a.93.93,0,0,0-.92-.93Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.19,
    y: 320.68,
    width: 2.17,
    height: 4.04,
    rx: 1.03,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.63,
    y: 320.68,
    width: 2.17,
    height: 4.04,
    rx: 1.03,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.83,
    y: 327.03,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.15,
    y: 327.03,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.83,
    y: 331.12,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.15,
    y: 331.12,
    width: 2.17,
    height: 2.17,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.89,356.25v2.44h-9.77v-1.94l5-4.71c1.14-1.09,1.34-1.76,1.34-2.39,0-1-.7-1.6-2.07-1.6a3.14,3.14,0,0,0-2.67,1.29l-2.19-1.41a6,6,0,0,1,5.14-2.4c2.88,0,4.81,1.48,4.81,3.83,0,1.25-.35,2.4-2.17,4.08l-3,2.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9,354.62c0,2.29-1.68,4.29-5.38,4.29a8.92,8.92,0,0,1-4.93-1.39l1.18-2.29a6.23,6.23,0,0,0,3.68,1.17c1.5,0,2.42-.63,2.42-1.68s-.66-1.69-3-1.69h-3.31l.67-7.28h7.89v2.41h-5.4l-.2,2.45h1.05C242.39,350.61,243.9,352.33,243.9,354.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,362.69c0,.14-5.82.26-13,.26s-13-.12-13-.26,5.82-.26,13-.26S243.72,362.54,243.72,362.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.21,366.56a67.8,67.8,0,0,1-8.33.26,68,68,0,0,1-8.34-.26,68,68,0,0,1,8.34-.26A67.8,67.8,0,0,1,241.21,366.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,375.46c-.14,0-.26-13.81-.26-30.83s.12-30.84.26-30.84.26,13.8.26,30.84S260,375.46,259.89,375.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,321.41a3.47,3.47,0,0,1,2-2.77,9.44,9.44,0,0,1,3.45-.83,30.32,30.32,0,0,1,5.55-.15,5.79,5.79,0,0,1,2.63.73c1.69,1.07,2.11,3.41,1.77,5.38a3.35,3.35,0,0,1-1,2.07,3.54,3.54,0,0,1-1.16.55,23.78,23.78,0,0,1-10.89.89c-1.09-.16-2.35-.56-2.7-1.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.12,320.35a3.48,3.48,0,0,0-2-2.77,9.38,9.38,0,0,0-3.45-.82,29.43,29.43,0,0,0-5.55-.14,5.79,5.79,0,0,0-2.63.73c-1.69,1.08-2.11,3.41-1.76,5.38a3.28,3.28,0,0,0,1,2.07,3.49,3.49,0,0,0,1.15.55,24,24,0,0,0,10.9.88c1.09-.17,2.35-.57,2.69-1.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,322c-6.74.18-15.23-.75-17.52-1.4s-12.18-3.58-17,1.1-9.54,35.7-9.21,42.12,8.49,10.87,13.39,8,11.63-16.11,13.26-16.33,6.31,1.95,9.35-.23a28.7,28.7,0,0,0,4.57-3.92s6.09-.22,6.64-.22,2.61,4.13,5.55,5,8.27-.77,9-1.1,5.88,9.68,11.11,14.68,14.91,1.95,15.44-6-8.73-36.76-11.89-40.89-14.47-2.93-19.26-1.51S391.26,321.87,387,322Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.21,364.61c-5.23-5-10.35-15-11.11-14.68s-6.1,2-9,1.09-5-5-5.56-5-6.63.23-6.63.23a29.3,29.3,0,0,1-4.57,3.92c-3,2.18-7.72,0-9.36.22s-8.36,13.5-13.26,16.33c-4.59,2.66-12.06-1.1-13.24-6.88a33.8,33.8,0,0,0-.14,4c.33,6.42,8.49,10.87,13.39,8s11.63-16.11,13.26-16.33,6.31,1.95,9.35-.23a28.7,28.7,0,0,0,4.57-3.92s6.09-.22,6.64-.22,2.61,4.13,5.55,5,8.27-.77,9-1.1,5.88,9.68,11.11,14.68,14.91,1.95,15.44-6a19.52,19.52,0,0,0-.2-3.69C429.93,366.9,421.11,369.3,416.21,364.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.52,
    cy: 333.84,
    r: 9.65,
    transform: "translate(-93.7 148.46) rotate(-20.46)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.22,333a9.65,9.65,0,1,1-9.66-9.65A9.63,9.63,0,0,1,373.22,333Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.22,333a18.82,18.82,0,0,0-.4-2.33,9.56,9.56,0,0,0-3.53-5.19,9.27,9.27,0,0,0-4-1.74,9.44,9.44,0,0,0-4.95.43,8.77,8.77,0,0,0-2.38,1.29,9,9,0,0,0-2,2,9.35,9.35,0,0,0,0,11.1,8.79,8.79,0,0,0,2,2,9,9,0,0,0,2.37,1.28,9.52,9.52,0,0,0,12.45-6.51,19.17,19.17,0,0,0,.4-2.33,7.28,7.28,0,0,1-.2,2.38,9.7,9.7,0,0,1-7.62,7.31,9.81,9.81,0,0,1-5.19-.39,10,10,0,0,1-4.61-3.43,9.83,9.83,0,0,1,0-11.71,9.1,9.1,0,0,1,2.1-2.1,9.23,9.23,0,0,1,2.51-1.34,9.74,9.74,0,0,1,12.82,6.9A7.28,7.28,0,0,1,373.22,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.77,334.31a9.65,9.65,0,1,1-9.66-9.65A9.64,9.64,0,0,1,420.77,334.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.13,
    cy: 332.93,
    r: 9.65,
    transform: "translate(-3.93 4.93) rotate(-0.68)",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.13,
    cy: 332.93,
    r: 9.65,
    transform: "translate(-3.93 4.93) rotate(-0.68)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.78,332.93a18.82,18.82,0,0,0-.4-2.33,9.56,9.56,0,0,0-3.53-5.19,9.27,9.27,0,0,0-4-1.74,9.44,9.44,0,0,0-4.95.43,8.77,8.77,0,0,0-2.38,1.29,9,9,0,0,0-2,2,9.35,9.35,0,0,0,0,11.1,8.79,8.79,0,0,0,2,2,9,9,0,0,0,2.37,1.28,9.52,9.52,0,0,0,12.45-6.51,19.17,19.17,0,0,0,.4-2.33,7.28,7.28,0,0,1-.2,2.38,9.7,9.7,0,0,1-7.62,7.31,9.81,9.81,0,0,1-5.19-.39,10,10,0,0,1-4.61-3.43,9.83,9.83,0,0,1,0-11.71,9.1,9.1,0,0,1,2.1-2.1,9.23,9.23,0,0,1,2.51-1.34,9.77,9.77,0,0,1,9.32,1.46,9.68,9.68,0,0,1,3.5,5.44A7.28,7.28,0,0,1,421.78,332.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,347.49a6.5,6.5,0,1,1-6.5-6.49A6.49,6.49,0,0,1,405,347.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,347.49c-.06,0,0-.58-.3-1.56a6.54,6.54,0,0,0-2.38-3.45,6.33,6.33,0,0,0-6-.86,6.3,6.3,0,0,0-4.1,5.88,6.39,6.39,0,0,0,1.21,3.69,6.15,6.15,0,0,0,2.9,2.18,6.29,6.29,0,0,0,5.95-.86,6.44,6.44,0,0,0,2.37-3.46c.27-1,.24-1.56.3-1.56s0,.14,0,.42a5,5,0,0,1-.13,1.19,6.43,6.43,0,0,1-2.35,3.7,6.69,6.69,0,0,1-9.48-1.31,6.69,6.69,0,0,1,0-8,6.66,6.66,0,0,1,9.47-1.32,6.41,6.41,0,0,1,2.35,3.69,4.66,4.66,0,0,1,.14,1.2C405.06,347.35,405.05,347.49,405,347.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.89,
    cy: 347.52,
    r: 6.49,
    transform: "translate(-136.25 354.05) rotate(-43.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.38,347.51c-.05,0,0-.58-.3-1.56a6.42,6.42,0,0,0-2.38-3.45,6.28,6.28,0,0,0-10,5,6.25,6.25,0,0,0,1.21,3.69,6.14,6.14,0,0,0,2.89,2.18,6.32,6.32,0,0,0,5.95-.86,6.44,6.44,0,0,0,2.37-3.46c.27-1,.25-1.56.3-1.56a1.24,1.24,0,0,1,0,.42,5.14,5.14,0,0,1-.14,1.19,6.46,6.46,0,0,1-2.34,3.7,6.67,6.67,0,0,1-6.34,1,6.54,6.54,0,0,1-3.14-2.33,6.68,6.68,0,0,1-1.32-4,6.76,6.76,0,0,1,1.31-4,6.68,6.68,0,0,1,9.48-1.33,6.46,6.46,0,0,1,2.35,3.7,5.76,5.76,0,0,1,.14,1.19A1.24,1.24,0,0,1,381.38,347.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61,330.29h-2.36v-2.36a2,2,0,0,0-2-2h-1.43a2,2,0,0,0-2,2v2.36h-2.36a2,2,0,0,0-2,2v1.42a2,2,0,0,0,2,2h2.37V338a2,2,0,0,0,2,2h1.43a2,2,0,0,0,2-2v-2.36h2.37a2,2,0,0,0,2-2v-1.43A2,2,0,0,0,368.61,330.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.06,328.08a2.84,2.84,0,1,1-2.84-2.84A2.85,2.85,0,0,1,415.06,328.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,333.09a2.85,2.85,0,1,1-2.85-2.83A2.85,2.85,0,0,1,420.81,333.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.07,337.71a2.84,2.84,0,1,1-2.84-2.84A2.85,2.85,0,0,1,415.07,337.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.08,333.18a2.84,2.84,0,1,1-2.84-2.84A2.85,2.85,0,0,1,409.08,333.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,321.9c-4.79,1.42-9.25.55-13.49.67a96.8,96.8,0,0,1-11.72-.52,9.88,9.88,0,0,0,.12,1.22l1.26,8.72a3.6,3.6,0,0,0,.67,1.91,3.51,3.51,0,0,0,2.27.87,97.42,97.42,0,0,0,10.38.68,23.06,23.06,0,0,0,7.22-.79,2.25,2.25,0,0,0,.93-.49,2.34,2.34,0,0,0,.43-.81,40.49,40.49,0,0,0,2.34-11.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,361.06c-.14.85-.57,1.27-1.27,1.28a1.09,1.09,0,0,1-.65-.2,1.47,1.47,0,0,1-.6-1.31l2.9-21.5a3,3,0,0,1,.07-.51,1.13,1.13,0,0,1,1.09-.72,1.17,1.17,0,0,1,.57.16,1.23,1.23,0,0,1,.66,1.06l-1,8.39q7.71-8.62,8.09-8.95a1.59,1.59,0,0,1,1.07-.55,1.23,1.23,0,0,1,.64.19,1.14,1.14,0,0,1,.59,1,1.81,1.81,0,0,1-.34,1q-.42.54-9.66,10.69l2.28,2.07q6.57,5.91,7.47,6.82a1.72,1.72,0,0,1,.59,1.1,1.2,1.2,0,0,1-.21.67,1.15,1.15,0,0,1-1,.57,1.67,1.67,0,0,1-1-.34q-.52-.37-9.26-8.42C276.54,357.47,276.21,360,276,361.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.69,361.09c-.15.85-.57,1.28-1.24,1.29a1.13,1.13,0,0,1-.67-.21,1.45,1.45,0,0,1-.61-1.31l2.89-21.5a3.4,3.4,0,0,1,.06-.46,1.16,1.16,0,0,1,1.15-.76,1.25,1.25,0,0,1,.59.14,1.17,1.17,0,0,1,.65,1Q294.84,360.34,294.69,361.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,361.12c-.11.81-.52,1.21-1.24,1.22a1.58,1.58,0,0,1-1.33-.92l-7.9-18.05c-.1.85-.22,1.81-.36,2.87q-1.56,13-1.87,14.82c-.14.85-.57,1.27-1.28,1.28a1.15,1.15,0,0,1-.67-.2,1.45,1.45,0,0,1-.61-1.31q2.82-21.45,2.84-21.51a1.74,1.74,0,0,1,.17-.5,1.29,1.29,0,0,1,1.16-.64c.68,0,1.11.2,1.31.61l7.87,17.67,2.29-17.08a1.33,1.33,0,0,1,.15-.54,1.07,1.07,0,0,1,1-.69,1.29,1.29,0,0,1,.62.17,1.19,1.19,0,0,1,.59,1.07c0,.35-.09.73-.14,1.14Q316.2,359,315.84,361.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.08,350.1h5.81a1.22,1.22,0,0,1,.62.16,1.17,1.17,0,0,1,.63,1.09,1.32,1.32,0,0,1-.05.37c-.11.49-.24,1-.39,1.49a16.48,16.48,0,0,1-3.64,6.57,6.86,6.86,0,0,1-4.95,2.56,5.58,5.58,0,0,1-.7,0,5.65,5.65,0,0,1-4-2.86,13,13,0,0,1-1.74-7,18.8,18.8,0,0,1,.69-5,16.71,16.71,0,0,1,3.45-6.73A7,7,0,0,1,331.1,338a4.89,4.89,0,0,1,2.2.5,7.11,7.11,0,0,1,3.39,4.24,1.34,1.34,0,0,1,.14.58,1.29,1.29,0,0,1-.17.62,1.18,1.18,0,0,1-1.08.62,1.32,1.32,0,0,1-.39-.06,1.16,1.16,0,0,1-.8-.78l-.06-.11a6.38,6.38,0,0,0-.7-1.38,3.35,3.35,0,0,0-2.78-1.66,3.29,3.29,0,0,0-1.93.71,10.38,10.38,0,0,0-3.17,4.55,17.31,17.31,0,0,0-1.37,6.56,11.7,11.7,0,0,0,1,5.15q1.11,2.28,3,2.28a4.19,4.19,0,0,0,2.81-1.7,15.51,15.51,0,0,0,3-5.39c-2.67,0-4.06,0-4.17-.05-.9-.15-1.37-.62-1.39-1.41a1.47,1.47,0,0,1,.13-.42A1.31,1.31,0,0,1,330.08,350.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,324.24l.5.91a6,6,0,0,0,2.43,2.43l.91.51-.91.5a6,6,0,0,0-2.43,2.43l-.5.91-.5-.91a6.13,6.13,0,0,0-2.44-2.43l-.91-.5.91-.51a6.13,6.13,0,0,0,2.44-2.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,363.33l.5.92a6.11,6.11,0,0,0,2.43,2.43l.91.5-.91.5a6.11,6.11,0,0,0-2.43,2.43l-.5.92-.5-.92a6.2,6.2,0,0,0-2.44-2.43l-.91-.5.91-.5a6.2,6.2,0,0,0,2.44-2.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,320l.5.91a6,6,0,0,0,2.43,2.43l.91.5-.91.5a6.13,6.13,0,0,0-2.43,2.44l-.5.91-.5-.91a6.22,6.22,0,0,0-2.44-2.44l-.91-.5.91-.5a6.13,6.13,0,0,0,2.44-2.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,367.15l.25.46a3.15,3.15,0,0,0,1.22,1.21l.46.25-.46.25a3.18,3.18,0,0,0-1.22,1.22l-.25.46-.25-.46a3.09,3.09,0,0,0-1.21-1.22l-.46-.25.46-.25a3.06,3.06,0,0,0,1.21-1.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,358.91l.25.46a3.15,3.15,0,0,0,1.22,1.21l.46.25-.46.25A3.11,3.11,0,0,0,388,362.3l-.25.45-.25-.45a3,3,0,0,0-1.21-1.22l-.46-.25.46-.25a3.06,3.06,0,0,0,1.21-1.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.75,
    y: 213.79,
    width: 208.84,
    height: 68.76,
    transform: "translate(-84.33 276.67) rotate(-42.01)",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.66,304.31c-3.62-3.94-3.19-9.54.88-13.29a9.15,9.15,0,0,1,7.52-2.63l-.3,3.58a5.71,5.71,0,0,0-4.7,1.49,5.69,5.69,0,0,0,7.7,8.37,5.68,5.68,0,0,0,1.87-4.57h3.59a9.14,9.14,0,0,1-3.25,7.31C267.91,308.3,262.29,308.26,258.66,304.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,287l-6.07,5.58,1.42,3.87-3.1,2.86L271,280.88l3-2.75,17.89,7.7-3.18,2.92Zm-3.07-1.42-6.68-3.11,2.54,6.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.21,260.46l12,13.09-2.48,2.28-13.83-1.94,7.31,7.94-3,2.75-12-13.08,2.51-2.3,13.81,2-7.31-8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,264.91c-3.62-3.94-3.19-9.55.88-13.29A9.19,9.19,0,0,1,309.9,249l-.3,3.58a5.72,5.72,0,0,0-4.7,1.5,5.69,5.69,0,0,0,7.7,8.37,5.68,5.68,0,0,0,1.87-4.58h3.59a9.11,9.11,0,0,1-3.25,7.3C310.75,268.89,305.13,268.85,301.5,264.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93,246.36l2.24,2.42L322,258.1,310,245l9.89-9.09,2.23,2.43-6.87,6.32,2.61,2.84,6.07-5.58,2.17,2.35L320,249.88l2.78,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,233.49l3-2.79,9.76,10.62,6.56-6,2.27,2.46-9.59,8.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.83,223.11l3-2.78,9.77,10.61,6.56-6,2.26,2.46-9.58,8.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,214.07l2.23,2.43-10.13,9.31-12-13.08,9.89-9.09,2.23,2.43-6.88,6.32,2.62,2.84,6.07-5.58L361.2,212l-6.07,5.59,2.79,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,201.2l5.94-5.47c4.28-3.93,9.58-4,13.23-.09s3.08,9.24-1.2,13.18l-5.94,5.46Zm15.54,5.27c2.59-2.39,2.87-5.51.56-8s-5.43-2.49-8-.1L363,200.9l7.46,8.11Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.d2784c7529b814b9bc64e332e68ed684.svg";
export { ForwardRef as ReactComponent };